import gql from 'graphql-tag'

const OfferResultFragment = gql`
  fragment dooerComPreOfferResult on AccountingOnboardingSyncedPreOfferResult {
    status
    estimatedMonthlyPriceAmount
    estimatedMonthlyPriceCurrency
    rejectionReasons
    syncedByFirstName
    syncedByLastName
    ownerEmail
    syncedCompanyInfo {
      propertyMessage
      propertyValue
    }
    syncedBankInfo {
      propertyMessage
      propertyValue
    }
    syncSessionId
  }
`

export const preOfferQuery = gql`
  query DooerComBankPreOfferQuery($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      name
      owner {
        id
        firstName
        lastName
        sePersonnummer
        email
      }
      accountingOnboardingSyncedPreOffer {
        id
        idNumber
        organizationNumber
        ...dooerComPreOfferResult
      }
    }
  }

  ${OfferResultFragment}
`

export const preOfferMutation = gql`
  mutation DooerComBankPreOfferMutation(
    $organizationId: ID!
    $status: AccountingOnboardingSyncedPreOfferStatus!
    $businessInfo: JSON
    $bankInstitution: AccountingOnboardingSyncedPreOfferBank
    $organizationNumber: String
  ) {
    organization(id: $organizationId) {
      accountingOnboardingSyncedPreOffer {
        changeStatus(
          status: $status
          businessInfo: $businessInfo
          bankInstitution: $bankInstitution
          organizationNumber: $organizationNumber
        )
      }
    }
  }
`

export const preOfferSubscription = gql`
  subscription SumifyBankSyncSyncedPreOfferSubscription($id: ID!, $filter: String) {
    preOfferStateChanged(id: $id) {
      id

      organization {
        id

        subscriptionOffers(first: -1, filter: $filter) {
          edges {
            node {
              id
              feeExVat
            }
          }
        }
      }
    }
  }
`
